export interface IProduct {
  ProductCategory: string;
  ProductDescription: string;
  ID: number;
  ProductIcon: string;
  ProductName: string;
  Versions: IProductVersion[];
  ProductPatchMode: string;
}

export interface IProductVersion {
  ProductVersionName: string;
  ID: number;
  ProductVersionDescription: string;
  ProductID: string;
  Nodes: IProductPackageNode[];
}

export interface IProductPackageNode {
  ID: number;
  ProductPackageNodeName: string;
  ProductPackageNodeType: string;
  ProductPackageNodeDescription: string;
  ProductPackageNodeChangeLog: string;
  ProductVersionID: number;
  Nodes: IProductPackageNode[];
  Artifacts: IArtifact[];
  ProductCode: string;
  CreatedAt: string;
  ReleaseTime: string;
  ResourceRequirement: string;
}

export interface IArtifact {
  ID: number;
  ArtifactName: string;
  ArtifactDescription: string;
  ArtifactChecksum: string;
  ArtifactType: string;
  DownloadURL: string;
  ProductPackageNodeID: string;
  SizeDisplay: string;
}

export interface IOption {
  label: string;
  value: string;
}

export const PackageNodeTypeBaseline = 'baseline';
export const PackageNodeTypePatch = 'patch';

export const PatchPageList = 'list';
export const PatchPageDetails = 'details';

export const ProductPatchModeMix = 'mix';
export const ProductPatchModeStandalone = 'standanlone';
export const ProductPatchModeOffline = 'offline';
